import React from 'react';
import { Sparkles, Crown, Users, Heart, BookOpen, Gift, MessageSquare, Globe } from 'lucide-react';
import { categories } from '../mock';

const iconMap = {
  Sparkles: Sparkles,
  Crown: Crown,
  Users: Users,
  Heart: Heart,
  BookOpen: BookOpen,
  Gift: Gift,
  MessageSquare: MessageSquare,
  Globe: Globe
};

const Apologetics = () => {
  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Apologetics</h1>
        <p className="body-large page-subtitle">
          Defending the truth of Christianity through Scripture, logic, and evidence.
        </p>

        <div className="categories-grid">
          {categories.map((category, index) => {
            const Icon = iconMap[category.icon];
            return (
              <div key={index} className="category-card">
                <div className="category-icon">
                  {Icon && <Icon size={32} />}
                </div>
                <h3 className="heading-3">{category.name}</h3>
                <p className="body-medium">{category.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="section-container">
        <h2 className="display-medium section-title">Key Apologetic Areas</h2>
        
        <div className="apologetics-sections">
          <div className="apologetics-section-card">
            <h3 className="heading-2">Classical Apologetics</h3>
            <p className="body-large">
              Defending the existence of God through cosmological, teleological, and moral arguments.
            </p>
            <ul className="section-list">
              <li className="body-medium">Cosmological Argument (Kalam)</li>
              <li className="body-medium">Teleological Argument (Design)</li>
              <li className="body-medium">Moral Argument</li>
              <li className="body-medium">Ontological Argument</li>
            </ul>
          </div>

          <div className="apologetics-section-card">
            <h3 className="heading-2">Historical Apologetics</h3>
            <p className="body-large">
              Examining the historical evidence for the resurrection and reliability of Scripture.
            </p>
            <ul className="section-list">
              <li className="body-medium">Resurrection Evidence</li>
              <li className="body-medium">Manuscript Reliability</li>
              <li className="body-medium">Archaeological Confirmation</li>
              <li className="body-medium">Eyewitness Testimony</li>
            </ul>
          </div>

          <div className="apologetics-section-card">
            <h3 className="heading-2">Philosophical Apologetics</h3>
            <p className="body-large">
              Engaging philosophical objections to Christianity and theism.
            </p>
            <ul className="section-list">
              <li className="body-medium">Problem of Evil</li>
              <li className="body-medium">Divine Hiddenness</li>
              <li className="body-medium">Free Will & Determinism</li>
              <li className="body-medium">Nature of Truth</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Apologetics;
